import { ActionIcon, Card, CardSection, Group, Image, LoadingOverlay, Text } from "@mantine/core";
import React from "react";
import { useQuery } from "react-query";
import BackendServiceV2 from "services/v2/BackendService";
import { ArrowRight } from "tabler-icons-react";

export function DevelopmentVariationsCard({variation}) {

    const {data: teleport, isLoading} = useQuery(['development-variation-card', variation.idTeleport], () => {
        return BackendServiceV2.get(`/teleport/${variation.idTeleport}`);
    });

    return (<>
        <LoadingOverlay visible={isLoading} />

        {!variation?.idTeleport && 
            <Card withBorder>
                <Text size="sm" color="dimmed">Variação não configurada</Text>
            </Card>
        }
    
        {teleport &&
            <Card withBorder p={10}>
                <CardSection>
                    {teleport?.personalization?.loadBackground?.webp &&
                        <Image src={window.ENV.StaticURL + teleport?.personalization?.loadBackground?.webp} height={120} />
                    }
                </CardSection>

                <Group mt={10}>
                    <Text size="sm">{teleport.metadata.title}</Text>
                    <ActionIcon ml="auto" component="a" href={'/teleport/' + teleport.id} target="_blank" color="#ff5e00" title="Abrir"><ArrowRight /></ActionIcon>
                </Group>
            </Card>
        }
    </>
    )
}